import React from 'react';
import { PagingDesktopStyled } from './styles';
function LayoutPage({ vertical, buttonType, onClick }) {
    return (React.createElement(PagingDesktopStyled, { "$vertical": vertical, "$type": buttonType, onClick: onClick }, buttonType));
}
export default React.memo(LayoutPage);
